<product-card [product]="item" [lazyPrice]="true"></product-card>
